/** @format */
// 默认配置
export const echartDefaultOption = {
  color: ['#3083E4', '#00E5C2', '#25CBFF', '#6F5EFA', '#FF5C62', '#FF9846'],
  grid: {
    left: '10px',
    right: '20px',
    top: '30px',
    bottom: '20px',
    containLabel: true
  }
}

// tooltip位置
export const echartTooltipOptions = {
  trigger: 'axis',
  enterable: true,
  position: function (point, params, dom, rect, size) {
    const { contentSize, viewSize } = size
    let x, y
    // x
    if (point[0] > viewSize[0] - contentSize[0]) {
      x = point[0] - contentSize[0]
    } else {
      x = point[0]
    }
    // y
    if (point[1] > viewSize[1] - contentSize[1]) {
      y = point[1] - contentSize[1]
    } else {
      y = point[1]
    }
    x = x < 0 ? 0 : x
    return [x, y]
  }
}
